module.exports = __webpack_public_path__ + "static/media/codetry_1.3bc98c84.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/codetry_1.jpg
// module id = 5759
// module chunks = 0